<template>
  <div class="app-text" v-html="txt"></div>
</template>

<script>
export default {
  data(){
    return{
      txt:''
    }
  },
  mounted() {
    this.getPage();
  },
  methods:{


    getPage(){
      let vm = this;
      vm.ajax("page", "get", 'id=2', e => {
        vm.txt = e.data.content
      })
    }
  }
}
</script>

<style>

</style>





// WEBPACK FOOTER //
// src/integralexplanation.vue